import { LargeCommercialPack } from '../models/large_commercial_pack';
import { GreatValuePriceUtil } from '../util/great_value_price_util';

export class LargeCommercialPackAction {

  // 初期表示
  static init() {
    /// ローカルストレージの大業パまとめ買い表表示を取得し表示を制御する
    LargeCommercialPack.checkCommercialPackList();
  }

  /// 大業パまとめ買い表の一定期間表示しないチェッボックス選択時ローカルストレージに選択状況を更新する
  static changeCommercialPackCheckbox() {
    LargeCommercialPack.changeCommercialPackCheckbox();
  }

  /// 大業パ商品に対して数量変更を行った場合、販売価格（税込）、販売価格（税抜）を数量変更時商品販売価格再計算結果リストの値に再描画する
  static async changeCartQuantity(quantity: number) {
    /// 大業パ商品であるか判別
    const isLargeCommercialPack = (document.getElementById(
      'isLargeCommercialPack'
    ) as HTMLInputElement).value;
    if (isLargeCommercialPack === 'true') {
      const result = this.getLargeCommercialPackBulkRange(quantity);
      if (!result) return;

      /// カゴエリアの販売価格（税込）、販売価格（税抜）の再描画
      const salesPriceTaxExclude = document.getElementById('salesPriceTaxExclude');
      if (salesPriceTaxExclude !== null && result.salesPriceTaxExclude !== null) {
        salesPriceTaxExclude.textContent = `／ ￥${result.salesPriceTaxExclude.toLocaleString()} （税抜き）`;
      } else if (salesPriceTaxExclude !== null) {
        salesPriceTaxExclude.textContent = '';
      } else {
        // salesPriceTaxExclude がNullのため、何もしない
      }
      const salesPriceTaxInclude = document.getElementById('salesPriceTaxInclude');
      if (salesPriceTaxInclude !== null && result.salesPriceTaxInclude !== null) {
        salesPriceTaxInclude.textContent = `￥${result.salesPriceTaxInclude.toLocaleString()}`;
      } else if (salesPriceTaxInclude !== null) {
        salesPriceTaxInclude.textContent = '';
      } else {
        // salesPriceTaxInclude がNullのため、何もしない
      }
      // 価格を再算出後、定期便の「お得な価格」を動的に変更する
      GreatValuePriceUtil.reRenderGreatValuePrice();
    }
  }

  private static getLargeCommercialPackBulkRanges() {
    const elements = document.getElementsByName('largeCommercialPackBulkRange');
    return Array.from(elements).map((element) => {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      return new LargeCommercialPackBulkRange(
        Number((element as HTMLInputElement).value),
        Number(element.dataset.taxincludedsalesprice),
        Number(element.dataset.taxexcludedsalesprice)
      );
    });
  }

  private static getLargeCommercialPackBulkRange(quantity: number) {
    const ranges = this.getLargeCommercialPackBulkRanges();
    const range = ranges.find((range) => range.count === quantity);
    if (range) return range;
    const limitRange = ranges[ranges.length - 1];
    if (limitRange.count < quantity) return limitRange;
    return undefined;
  }
}

class LargeCommercialPackBulkRange {
  constructor(
    public count: number,
    public salesPriceTaxInclude: number,
    public salesPriceTaxExclude: number
  ) {}
}
